export const SUCCESS = "SUCCESS"

export const FAILURE = "FAILURE"

export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const LOGIN_FAILURE = "LOGIN_FAILURE"

export const ADD_PROFILE = "ADD_PROFILE"

export const REMOVE_PROFILE = "REMOVE_PROFILE"

export const USER_INPUT_CHANGE = "USER_INPUT_CHANGE"

export const USER_INPUT_SUBMIT = "USER_INPUT_SUBMIT"

export const NAVIGATE = "NAVIGATE"

export const SET_ACTIVE_SOURCE = "SET_ACTIVE_SOURCE"

export const SET_SOURCES = "SET_SOURCES"

export const GET_REPORT_MARKUP = "GET_REPORT_MARKUP"

export const SET_TEXT_OVERLAY = "SET_TEXT_OVERLAY"

export const SET_OVERLAY_STATISTICS = "SET_OVERLAY_STATISTICS"

export const GET_REPORT = "GET_REPORT"

export const GET_LIBRARY = "GET_LIBRARY"

export const GET_REPORT_STATUS = "GET_REPORT_STATUS"

export const SET_SEARCHED_SOURCES = "SET_SEARCHED_SOURCES"

export const OPEN_TOASTR = "OPEN_TOASTR"

export const SET_SOURCE_MARKUP = "SET_SOURCE_MARKUP"

export const TOGGLE_UI_FILTER = "TOGGLE_UI_FILTER"

export const CHANGE_REPORT_CARD = "CHANGE_REPORT_CARD"

export const CHANGE_LIBRARY_CARD = "CHANGE_LIBRARY_CARD"

export const GET_PROJECT = "GET_PROJECT"

export const GET_PROJECT_FILTER = "GET_PROJECT_FILTER"

export const GET_REPORTS = "GET_REPORTS"

export const GET_REPORTS_DASHBOARD = "GET_REPORTS_DASHBOARD"

export const SET_LIBTEXTS = "SET_LIBTEXTS"

export const RESET_REPORT = "RESET_REPORT"

export const GET_REPORT_STATUS_MESSAGE = "GET_REPORT_STATUS_MESSAGE"

export const SET_SOURCE_FILTER = "SET_SOURCE_FILTER"

export const RESET_NAVIGATE = "RESET_NAVIGATE"

export const CLEAR_REPORT_FILTER = "CLEAR_REPORT_FILTER"

export const CLEAR_LIBRARY_FILTER = "CLEAR_LIBRARY_FILTER"

export const CLEAR_PROJECT_FILTER = "CLEAR_PROJECT_FILTER"

export const APPLY_REPORT_FILTER = "APPLY_REPORT_FILTER"

export const APPLY_LIBRARY_FILTER = "APPLY_LIBRARY_FILTER"

export const OPEN_PAYMENT_DIALOG = "OPEN_PAYMENT_DIALOG"

export const PLAGIARISM_CHECK_DROP_DOWN = "PLAGIARISM_CHECK_DROP_DOWN"

export const SET_CREDIT_DATA = "SET_CREDIT_DATA"

export const SET_PROJECT_DATA = "SET_PROJECT_DATA"

export const SET_CHOSEN_PROJECTS = "SET_CHOSEN_PROJECTS"

export const INPUT_URL_POPUP = "INPUT_URL_POPUP"

export const CREATE_PROJECT_POPUP = "CREATE_PROJECT_POPUP"

export const SELECT_LIBRARY_SOURCE_POPUP = "SELECT_LIBRARY_SOURCE_POPUP"

export const SELECTED_LIBRARY_SOURCE_PROJECT = "SELECTED_LIBRARY_SOURCE_PROJECT"

export const SET_PROPERTIES_FORM_DATA = "SET_PROPERTIES_FORM_DATA"

export const SET_UPLOADED_FILES = "SET_UPLOADED_FILES"

export const SET_UPLOADED_FILES_STATUS = "SET_UPLOADED_FILES_STATUS"

export const CANCEL_FILES_UPLOAD = "CANCEL_FILES_UPLOAD"

export const REMOVE_UPLOADED_FILE = "REMOVE_UPLOADED_FILE"

export const SET_LANGUAGE = "SET_LANGUAGE"

export const RESET_NEWCHECK_SETTINGS = "RESET_NEWCHECK_SETTINGS"

export const PERFORMANCE_CHECK_LIST = "PERFORMANCE_CHECK_LIST"

export const REPORT_DETAILS = "REPORT_DETAILS"

export const HANDLE_PAGINATION = "HANDLE_PAGINATION"

export const HANDLE_LIBRARY_PAGINATION = "HANDLE_LIBRARY_PAGINATION"

export const APPLY_PROJECT_FILTER = "APPLY_PROJECT_FILTER"

export const HANDLE_PROJECT_PAGINATION = "HANDLE_PROJECT_PAGINATION"

export const SELECTED_ROW_TABLE = "SELECTED_ROW_TABLE"

export const CLEAR_REPORT_PERFORMACE_DATA = "CLEAR_REPORT_PERFORMACE_DATA"

export const OPEN_CONFIRMATION_POPUP = "OPEN_CONFIRMATION_POPUP"

export const SET_PROPERTIES_DATA_VALUE = "SET_PROPERTIES_DATA_VALUE"

export const CHANGE_REPORT_SELECTION = "CHANGE_REPORT_SELECTION"

export const CHANGE_PROJECT_SELECTION = "CHANGE_PROJECT_SELECTION"

export const CHANGE_LIBRARY_SELECTION = "CHANGE_LIBRARY_SELECTION"

export const SET_ACTIVE_REPORT = "SET_ACTIVE_REPORT"

export const SET_ACTIVE_LIBRARY = "SET_ACTIVE_LIBRARY"

export const NOTIFY_REPORTS_CHANGED = "NOTIFY_REPORTS_CHANGED"

export const NOTIFY_LICENSEUSERS_CHANGED = "NOTIFY_LICENSEUSERS_CHANGED"

export const NOTIFY_LIBRARIES_CHANGED = "NOTIFY_LIBRARIES_CHANGED"

export const NOTIFY_PROJECTS_CHANGED = "NOTIFY_PROJECTS_CHANGED"

export const SET_DRAFT_REPORT = "SET_DRAFT_REPORT"

export const SET_DRAFT_LIBRARY = "SET_DRAFT_LIBRARY"

export const SET_EXCLUDE_SOURCES = "SET_EXCLUDE_SOURCES"

export const SET_ACCEPT_SOURCE = "SET_ACCEPT_SOURCE"

export const OPEN_CONFIRMATION_DIALOG = "OPEN_CONFIRMATION_DIALOG"

export const OPEN_LOG_DIALOG = "OPEN_LOG_DIALOG"

export const OPEN_PASTE_DIALOG = "OPEN_PASTE_DIALOG"

export const CLOSE_CONFIRMATION_DIALOG = "CLOSE_CONFIRMATION_DIALOG"

export const CLOSE_LOG_DIALOG = "CLOSE_LOG_DIALOG"

export const CLOSE_PASTE_DIALOG = "CLOSE_PASTE_DIALOG"

export const CLOSE_CONFIRMATION_POPUP = "CLOSE_CONFIRMATION_POPUP"

export const SET_CHECKOUT_DETAILS = "SET_CHECKOUT_DETAILS"

export const SET_USER_DETAILS = "SET_USER_DETAILS"

export const SET_MESSAGE_LIST = "SET_MESSAGE_LIST"

export const GET_REPORT_STATISTICS_BY_MONTH = "GET_REPORT_STATISTICS_BY_MONTH"

export const GET_REPORT_STATISTICS_BY_PROJECT = "GET_REPORT_STATISTICS_BY_PROJECT"

export const GET_NEWS = "GET_NEWS"

export const GET_FAQS = "GET_FAQS"

export const SHOW_FULLSCREEN_LOADING = "SHOW_FULLSCREEN_LOADING"

export const SET_UI = "SET_UI"

export const SET_USER_SETTINGS = "SET_USER_SETTINGS"

export const SET_COMPARE_SETTINGS = "SET_COMPARE_SETTINGS"

export const OPEN_REPORT_DOWNLOAD_DIALOG = "OPEN_REPORT_DOWNLOAD_DIALOG";

export const SET_ORDERS = "SET_ORDERS"

export const SET_CREDIT_COSTS = "SET_CREDIT_COSTS"

export const SET_NEWCHECK_SETTINGS = "SET_NEWCHECK_SETTINGS"

export const SET_NEWTEXT_SETTINGS = "SET_NEWTEXT_SETTINGS"

export const SET_COLLUSION = "SET_COLLUSION"

export const SET_PENDING_COLLUSION_LIBTEXTS = "SET_PENDING_COLLUSION_LIBTEXTS"

export const SET_ADMINLICENSE = "SET_ADMINLICENSE"

export const SET_MAINTENANCE = "SET_MAINTENANCE"
